(function() {
    'use strict';

    angular
        .module('core')
        .directive('infoWindow', infoWindow);

    function infoWindow(
        $location,
        $routeParams,
        $filter,
        broker,
        preferences,
        occupancyService,
        resourceService,
        tripService,
        basketService,
        currentDestination,
        windowUtil,
        pageStrand,
        urlUtils,
        holidayDeals,
        hotelService) {
        // TODO this is a hack to let TR have a uniqiue template. The template needs to be an embedded string or
        // else the info window has a loading delay and can fail to load altogether on some devices.

            const viewHotelButton = `
            <div class="button-wrapper" style="position: absolute; bottom: 12px;"
                ng-if="hotel.Id != pageHotelId">
                <a class="o-button o-button--primary o-button--sm sc-c-button sc-c-button--primary sc-c-button--hollow"
                    ng-click="selectHotel(hotel)">
                    View hotel
                </a>
            </div>`;

            const templatesByTenant = {
            1: `
                <div class="hotel-info-window ">
                    <div class="hotel-image flex-item" ng-style="hotelImage"></div>
                    <div class="hotel-info">
                        <div>
                            <h4 class="heading-small hotel-name">
                                <a ng-if="hotel.Id != pageHotelId" ng-click="selectHotel(hotel)">
                                    <span ng-show="!pageHotelId">{{ ::hotel.Title }}</span>
                                    <span ng-show="pageHotelId">{{ ::(hotel.Name || hotel.Title) }}</span>
                                </a>
                                <span ng-if="hotel.Id == pageHotelId">{{ ::(hotel.Name || hotel.Title) }}</span>
                            </h4>
                            <ul class="ratings">
                                <li>
                                    <star-rating rating="::hotel.StarRating"></star-rating>
                                    <span ng-if="hotel.CustomerRatingCount > 0">
                                        <span class="customer-rating">
                                            <span class="rating">{{ ::hotel.CustomerRating }}</span>
                                            <span class="phrase">{{ ::hotel.CustomerRatingTitle }}</span>
                                            <span class="reviews">({{ ::hotel.CustomerRatingCount }} {{ ::reviewString }})</span>
                                        </a>
                                    </span>                        
                                </li>
                                <li>
                                    <div class="teaser-price" ng-if="!PackagePrice">
                                        <span ng-if="hotel.OriginalCostStr && hotel.OriginalCostStr!=hotel.displayPrice">
                                            <span class="price-was"> 
                                                <span class="price">{{ hotel.OriginalCostStr }}</span>
                                            </span>
                                        </span>
                                        <span class="price">
                                            {{hotel.displayPrice}}
                                        </span>
                                    </div>
                                </li>
                            </ul>
                        </div> 
                        ${viewHotelButton}
                    </div>
                </div>`
        };
        const templateFallback = `
            <div class="hotel-info-window">
                <div class="hotel-image" ng-style="hotelImage">
                    <shortlist-toggle hotel="hotel"> </shortlist-toggle>
                </div>
                <div class="hotel-info">
                    <h4 class="hotel-name ellipsis">
                        <a ng-if="hotel.Id != pageHotelId" ng-click="selectHotel(hotel)">
                            <span ng-show="!pageHotelId">{{ ::hotel.Title }}</span>
                            <span ng-show="pageHotelId">{{ ::(hotel.Name || hotel.Title) }}</span>
                        </a>
                        <span ng-if="hotel.Id == pageHotelId">{{ ::(hotel.Name || hotel.Title) }}</span>
                        <span ng-if="inlineStarsEnabled" class ="inline-stars stars-{{ ::hotel.StarRating }}"><rating stars="{{ ::hotel.StarRating }}"> </rating></span>
                    </h4>
                    <div class="hotel-location">
                        {{ ::hotel.AcomType }} | {{ ::hotel.Address }}
                    </div>
                    <rating stars="{{ ::hotel.StarRating }}"> </rating>
                    <div class="customer-rating" ng-if="hotel.CustomerRating > 0">
                        <span class="phrase"> {{ ::hotel.CustomerRating }} </span>
                        <span class="phrase"> {{ ::hotel.CustomerRatingTitle }} </span>
                        <span class="reviews" ng-if="::displayReviews">
                            ({{ ::hotel.CustomerRatingCount }} {{ ::reviewString }})
                        </span>
                    </div>
                    <div class="teaser-price" ng-if="!PackagePrice"> {{ hotel.displayPrice }} </div>
                    ${viewHotelButton}
                </div>
            </div>`;

        return {
            restrict: 'E',
            scope: true,
            template: templatesByTenant[TRPCONFIG.Domain.TenantId] ? templatesByTenant[TRPCONFIG.Domain.TenantId] : templateFallback,
            link
        };

        function link(scope) {
            const isTrip = !!$routeParams.tripId;
            const nonInfants = occupancyService.getNumberOfNonInfantPassengers();

            preferences.get('priceMode').then(pm => _calculatePrice(pm));
            tripService.usePackageRates().then(packagePrice => scope.PackagePrice = packagePrice);
            _setHotelId($routeParams.estabId);
            scope.inlineStarsEnabled = TRPCONFIG.Domain.InlineStarsEnabled;
            scope.hotelImage = { 'background-image': `url(${scope.hotel.ImageUrl})` };

            scope.reviewString = resourceService.get(
                scope.hotelCustomerRatingCount > 1 ? 'HOTELREVIEWS' : 'HOTELREVIEW'
            );

            scope.displayReviews = TRPCONFIG.Domain.ReviewsEnabled;

            broker.subscribe(
                `infoWindow${scope.$id}`,
                'priceModeChanged',
                e => _calculatePrice(e.data)
            );

            scope.$on('$destroy', () => {
                broker.unsubscribe(`infoWindow${scope.$id}`);
            });

            if (isTrip) {
                _setHotelId($routeParams.estabId);
                scope.selectButton = resourceService.get('SELECTHOTELTEXT');
                scope.selectHotel = _selectTripHotel;
            } else if (scope.dealsMode) {
                scope.selectButton = resourceService.get('SHOWDEALS');
                scope.selectHotel = () => _getDeals(scope.hotel);
            } else {
                scope.selectButton = resourceService.get('VIEWDETAILS');
                scope.selectHotel = _selectLandingHotel;
                currentDestination.getCurrentDestination().then(dest => {
                    _setHotelId(dest.EstablishmentId);
                });
            }

            function _setHotelId(id) {
                scope.pageHotelId = id || null;
            }

            function _calculatePrice(pm) {
                const costValue = pm === 0 ?
                                scope.hotel.MinCost / nonInfants :
                                scope.hotel.MinCost;

                if (costValue) {
                    scope.hotel.displayPrice = $filter('roundedCurrency')(costValue);
                }
            }

            function _selectTripHotel(h) {
                tripService.getTrip($routeParams.tripId).then(trip => {
                    basketService.selectHotel(trip.TripId, h, trip.BasketId);
                    hotelService.trackHotelClick(
                        _.get(h, 'Id'),
                        undefined,
                        undefined,
                        undefined,
                        _.get(trip, 'HotelsRequest.AvailabilitySearchId')
                    );
                });
            }

            function _getDeals(hotel) {
                holidayDeals
                    .getDealsFromMap(hotel.Id)
                    .then(hotelWithDeals => {
                        if (!hotelWithDeals) { return; }
                        hotel.HolidayDeals = hotelWithDeals.HolidayDeals;
                        hotel.TransferTimes = hotelWithDeals.TransferTimes;
                        hotel.Airports = hotelWithDeals.Airports;
                        broker.publish('SHOWDEALS', { hotel: holidayDeals.enrichHotel(hotel) });
                    });
            }

            function _selectLandingHotel(h) {
                currentDestination.getCurrentDestination().then(dest => {
                    const url = urlUtils.stripLeadingSlash(
                        pageStrand.adjustUrl(urlUtils.appendExistingQueryString(h.Url), dest.PageStrand)
                    );
                    if (TRPCONFIG.DeviceSettings.OpenHotelInNewWindow) {
                        windowUtil.open(url);
                    } else {
                        $location.path(url);
                    }
                });
            }
        }
    }
    })();

